import LupiService from '../../../services/lupi/lupiService';

const api = new LupiService()
const state = {
    produtos: [],
    loading_id: null,
}
const getters = {
    StateS9Produtos: state => state.produtos,
    StateS9ProdutosLoadingID: state => state.loading_id,
}
const mutations = {
    setS9Produtos(state, value){ state.produtos = value },
    setS9ProdutosLoadingID(state, value){ state.loading_id = value },
}
const actions = {
    /**  ------------------ S9Produtos ------------------- */
    async GetS9Produtos({ commit }, params) {
        // Busca produtos na base Lupi
        commit('setS9ProdutosLoadingID', 'list-produtos')
        try{
            const response = await api.get('lupi-produtos/',{ ...params, page_size: 100 })
            commit('setS9Produtos', response.data.results)
        }catch(error){
            commit("setAlerts", [ error.toast_message ])
        }
        commit('setS9ProdutosLoadingID', null)
    },
    
    
   
    /** Entrega de Materiais LUPI Pesquisa de Item */
    // async GetEntregaMaterialLupiPesquisaItemLupi({ commit }, params) {
    //     commit('setCheckListLoadingID', 'entrega-material-lupi-pesquisa-item')
    //     var result = {}
    //     try{
    //         const response = await api.get('entrega-material/consultar_item_lupi/', {...params, page_size: 100})
    //         result = response.data
    //     }catch(error){
    //         commit("setAlerts", [ error.toast_message ])
    //     }
    //     commit('setCheckListLoadingID', null)
    //     return result
    // },
}
export default {
    state,
    getters,
    actions,
    mutations
};